/**
 * 共通変数・関数
 * @constant {number} windowWidth - 画面幅
 * @constant {number} breakpoint - 画面幅の閾値
 * @constant {boolean} isMobile - スマホ判定
 * @constant {string} isActive - アクティブ化クラス
 * @constant {string} isDisabled - 無効化クラス
 */
export const windowWidth = window.innerWidth;
export const breakpoint = 768;
export const isMobile =
	windowWidth < breakpoint ||
	/iphone|ipod|android.*mobile|windows.*phone|blackberry.*mobile/.test(
		navigator.userAgent.toLowerCase(),
	);
export const isActive = 'is-active';

/**
 * ページが特定のクラス名を持っているかどうかを確認する関数
 * @param {string|string[]} pageNames - 確認するクラス名
 * @returns {boolean} - いずれかのクラス名が含まれている場合はtrue、それ以外はfalse
 */
export const isPage = (...pageNames) => {
	return pageNames.some((pageName) =>
		document.body.classList.contains(pageName),
	);
};
